(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8368],{

/***/ 21840:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mortgage-brokers/[slug]",
      function () {
        return __webpack_require__(95728);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 95728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/Directory/TopicPage.js
var TopicPage = __webpack_require__(69467);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./next-seo.config.js
var next_seo_config = __webpack_require__(5056);
// EXTERNAL MODULE: ./store/auth.js
var auth = __webpack_require__(32505);
// EXTERNAL MODULE: ./layouts/SidebarLayout.js + 2 modules
var SidebarLayout = __webpack_require__(22028);
// EXTERNAL MODULE: ./components/Typo.js
var Typo = __webpack_require__(23775);
// EXTERNAL MODULE: ./components/Directory/BrokerCard.js
var BrokerCard = __webpack_require__(18447);
// EXTERNAL MODULE: ./components/Directory/DirectoryStories.js
var DirectoryStories = __webpack_require__(21535);
// EXTERNAL MODULE: ./components/Directory/DirectoryBreadcrumb.js
var DirectoryBreadcrumb = __webpack_require__(72936);
// EXTERNAL MODULE: ./components/Directory/DirectoryNotes.js
var DirectoryNotes = __webpack_require__(57053);
// EXTERNAL MODULE: ./utils/directory.js
var directory = __webpack_require__(81455);
// EXTERNAL MODULE: ./utils/safe-html.js
var safe_html = __webpack_require__(95460);
// EXTERNAL MODULE: ./styles/modules/BrokerDirectory.module.scss
var BrokerDirectory_module = __webpack_require__(41361);
var BrokerDirectory_module_default = /*#__PURE__*/__webpack_require__.n(BrokerDirectory_module);
;// CONCATENATED MODULE: ./components/Directory/TownPage.js


















// A town page: every verified mortgage broker whose address is in the town,
// most third-party coverage first.
function TownPage(param) {
    var page = param.page;
    var isAuthenticated = (0,es/* useSelector */.v9)(auth/* authSelector */.aF).isAuthenticated;
    var town = page.town, brokers = page.brokers, stories = page.stories;
    var ref = (0,directory/* townCopy */.jY)(page), title = ref.title, heading = ref.heading, description = ref.description, intro = ref.intro;
    var path = (0,directory/* townPath */.OY)(town.slug);
    var url = "".concat("https://app.newspage.media").concat(path);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SidebarLayout/* default */.Z, {
        isAuthenticated: isAuthenticated,
        breadcrumb: false,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, next_seo_config/* default */.Z), {
                title: title,
                titleTemplate: "%s",
                description: description,
                canonical: url,
                noindex: !page.indexable,
                openGraph: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, next_seo_config/* default.openGraph */.Z.openGraph), {
                    title: title,
                    description: description,
                    url: url
                })
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: (0,safe_html/* jsonLd */.oL)((0,directory/* townSchema */.qZ)(page, "https://app.newspage.media"))
                    }
                }, "directory-jsonld")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (BrokerDirectory_module_default()).wrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DirectoryBreadcrumb/* default */.Z, {
                        items: [
                            [
                                "Newspage",
                                "/"
                            ],
                            [
                                "Mortgage brokers",
                                directory/* MORTGAGE_BROKERS_PATH */.kD
                            ],
                            [
                                town.name,
                                path
                            ], 
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (BrokerDirectory_module_default()).head,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typo/* default */.Z, {
                                variant: "h1",
                                children: heading
                            }),
                            intro ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (BrokerDirectory_module_default()).intro,
                                dangerouslySetInnerHTML: {
                                    __html: (0,safe_html/* default */.ZP)(intro)
                                }
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (BrokerDirectory_module_default()).intro,
                                children: (0,directory/* townIntro */.F1)(page)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DirectoryNotes/* default */.Z, {
                                updatedAt: (0,directory/* pageUpdatedAt */.tC)(page),
                                order: "Ordered by the number of pieces of media coverage, then by the most recent one."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: (BrokerDirectory_module_default()).list,
                        children: brokers.map(function(broker) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(BrokerCard/* default */.Z, {
                                broker: broker
                            }, broker.slug);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DirectoryStories/* default */.Z, {
                        stories: stories,
                        label: town.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (BrokerDirectory_module_default()).backLink,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: directory/* MORTGAGE_BROKERS_PATH */.kD,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: "All mortgage broker towns and topics"
                            })
                        })
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./pages/mortgage-brokers/[slug].js



// A town page when a town page has this slug, otherwise the topic (the API
// decides, see resolvePage); a topic it displaces lives under /topic/[slug].
var MortgageBrokerPage = function(param) {
    var page = param.page;
    if (page.kind === "town") return /*#__PURE__*/ (0,jsx_runtime.jsx)(TownPage, {
        page: page
    });
    if (page.kind === "topic") return /*#__PURE__*/ (0,jsx_runtime.jsx)(TopicPage/* default */.Z, {
        page: page
    });
    return null;
};
var __N_SSG = true;
// No wrapper.withRedux: _app.js already provides the store.
/* harmony default export */ var _slug_ = (MortgageBrokerPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1036,2017,8300,1455,9467,9774,2888,179], function() { return __webpack_exec__(21840); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);